// extracted by mini-css-extract-plugin
module.exports = {"label":"label__qN5a1","price":"price_-vpTQW","bigPrice":"bigPrice_1KqiOF","smallPrice":"smallPrice_3TSUHB","separator":"separator_1wW2WI"};